module.exports = __webpack_public_path__ + "img/CPTemp3.544d4217.png";